import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, addArrayValue } from 'redux-form';
import ficheValidation from './ficheValidation';
import * as FicheActions from 'redux/modules/fiches';
import form from './form.json';
import { generateFicheInputs } from 'utils/generateFicheInputs.js';

import { asyncConnect } from 'redux-connect';

var loc = form.localisation;
import sitesForm from './sites.json';
import productForm from './product.json';
import { LinkContainer } from 'react-router-bootstrap';
import { Tabs, Tab, Panel, Button } from 'react-bootstrap';
import { routeActions } from 'react-router-redux';
import validate from './ficheValidation';

import _ from 'underscore';

import { ProductList } from 'components';


import SiteStatePanel from './SiteStatePanel';

import SyncProductsTable from './SyncProductsTable';

var productForm2 = [];

_.each(productForm, (group) => {
	productForm2.push(_.flatten(group));
})

productForm2 = _.flatten(productForm2);




var fields = ['groups'];

_.each(sitesForm, (group) => {
	_.each(group.inputs, (input) => {
		fields.push('sites.' + input.name)
	})
})

fields.push('touched');

fields.push('products[].id');
for (var group in productForm) {
	var group_obj = productForm[group];
	for (var el in group_obj) {
		fields.push('products[].' + group_obj[el].name)
	}
}
fields.push('sites.id');
fields.push('sites.etat');

import { translate } from 'react-i18next';

@translate(['common'])
@reduxForm({
	form: 'editFicheForm',
	fields: fields,
	//asyncValidate,
	//asyncBlurFields:['sites.identification_GSM', 'products[].identification_ID'],
	validate,
	destroyOnUnmount: false
}, undefined, {
	addValue: addArrayValue
})
@connect(
	state => ({
		created: state.fiches.created,
		error: state.fiches.error,
		success: state.fiches.success,
		groups: state.groups.data,
		products: state.fiches.currentProducts,
		fiche: state.fiches.fiche,
		routeChanges: state.routing.location,
		user: state.auth.user,
		productsPanOpen: state.fiches.productsPanOpen,
		allProducts: state.products.data,
		productsListPanOpen: state.fiches.productsListPanOpen,
	}),
	dispatch => bindActionCreators({ ...FicheActions, ...routeActions }, dispatch)
)
export default class FicheForm extends Component {


	constructor(props) {
		super(props);
		this.addExistingProduct = this.addExistingProduct.bind(this);

	}

	componentWillUnmount() {
		if (this.props.action == 'create') {
			this.props.initializeForm(this.props.pristineValues);
		}
		this.props.dispatch(FicheActions.resetForm());
	}

	addExistingProduct(product) {

		var fields = this.props.fields;

		if (fields['products'].length < 8) {
			fields['products'].addField(product);
			if (this.props.productsPanOpen == false) {
				this.props.openProductsPan();
			}
			this.props.openProductsListPan();
		}
	}



	render() {
		const {
			asyncValidating,
			editStop,
			fields,
			formKey,
			handleSubmit,
			invalid,
			submitting,
			resetForm,
			createFiche,
			values,
			created,
			pristine,
			save,
			error,
			success,
			ficheId,
			groups,
			urlParams,
			products, fiche, user, productsPanOpen, productsListPanOpen, t
		} = this.props;

		var self = this;

		const styles = require('containers/Fiches/AddFiche.scss');

		if (error) {
			var errorObj = (
				<div className="alert alert-danger" role="alert">
					<span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
					{t('main.connection_error')}
				</div>);
		} else {
			var errorObj = <span />;
		}

		if (success != false) {
			var successObj = (
				<div className="alert alert-success" role="alert">
					<span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true">&nbsp;</span>
					{success}
					&nbsp;
        			<button className="btn btn-default" type="button" onClick={() => this.props.goBack()}>
						{t('main.return_to_fiches_list')}
				  	</button>
				</div>
			);
		} else {
			var successObj = <span />;
		}

		var className = "col-xs-6";

		var SitesformGroups = [];
		_.each(sitesForm, (group, key) => {
			var sitesInputs = [];
			_.each(group.inputs, (input) => {
				var prop = fields['sites'][input.name];
				var disabled = false;
				sitesInputs.push(generateFicheInputs(prop, input, disabled));
			})
			SitesformGroups.push(
				<fieldset key={'fieldset_' + key} className={className}>
					<legend>{key}</legend>
					{sitesInputs}
				</fieldset>
			);
		})

		var firstProductId = '';

		var tabs = [];
		fields['products'].map((product, index) => {

			if (index == 0) {
				firstProductId = product.identification_ID.initialValue;
			}

			index = parseInt(index);

			var productSize = _.size(fields['products']) - 1;

			var prevBtn = index > 0 ? <span onClick={() => {
				fields['products'].swapFields(index, index - 1);
				fields['touched'].onChange(true);
			}}> <i className={"fa fa-arrow-circle-left " + styles.nextBtnProduct} /></span> : ''

			var nextBtn = index < productSize ? <span onClick={() => {
				fields['products'].swapFields(index, index + 1);
				fields['touched'].onChange(true);
			}}> <i className={"fa fa-arrow-circle-right " + styles.nextBtnProduct} /></span> : ''

			var title = (
				<span>
					{prevBtn}
					&nbsp;
					{t('main.product')} {index + 1}
					{nextBtn}
					&nbsp;
		  		<i className={"fa fa-times-circle " + styles.deleteBtnProduct}
						onClick={() => {
							fields['products'].removeField(index);
							fields['touched'].onChange(true);
							//self.refs['tabContainer'].setState({activeKey:fields['products'].length})
						}} />

				</span>
			);

			var ProductformGroups = [];
			ProductformGroups.push(<h4 className="col-xs-12">{t('main.product')} {index + 1}</h4>);


			var address = product['localisation_adresse'].value;


			if (typeof address === 'object' && address != null) {

				var city = address.gmaps['address_components'].filter(function (addr) {
					return (addr.types[0] == 'locality') ? 1 : (addr.types[0] == 'administrative_area_level_1') ? 1 : 0;
				});

				product['localisation_ville'].value = city[0].long_name;
			}

			_.each(productForm, (inputs, group) => {
				var pform = [];
				_.each(inputs, (input) => {
					var city = product['localisation_ville'];
					pform.push(generateFicheInputs(product[input.name], input, false, city));
				})

				ProductformGroups.push(
					<fieldset key={'pform_fieldset_' + index + group} className={className}>
						<legend>{group}</legend>
						{pform}
					</fieldset>);
			});

			tabs.push(
				<Tab key={'tab' + index} eventKey={index} title={title} ref="">
					<div className="row">
						<br />
						{ProductformGroups}
					</div>
				</Tab>
			);
		});

		if (tabs.length > 0) {
			var tabContainer = <Tabs ref="tabContainer" animation={false} id="controlled-tab-example">
				{tabs}
			</Tabs>
		} else {
			var tabContainer = <span><b>{t('ficheForm.products_not_added')}</b></span>
		}

		var openIcon2 = this.props.productsListPanOpen ? <i style={{ cursor: 'pointer' }} className="fa fa-chevron-circle-down" /> : <i style={{ cursor: 'pointer' }} className="fa fa-chevron-circle-up" />;

		var listProducts = [];

		var addedProducts = fields['products'].map(function (p) {
			return p['id']['initialValue']
		})

		_.each(this.props.allProducts, function (p) {
			if (_.indexOf(addedProducts, p.id) == -1) {
				listProducts.push(p);
			}
		});

		var tabWrapper = //tabs.length > 0 ? (
			<Panel collapsible expanded={this.props.productsPanOpen}>

				<div style={{ position: 'absolute', right: 25, 'zIndex': '100', 'textAlign': 'right' }}>
					<button style={{ margin: '0px' }} className="btn btn-primary btn-sm " type="button" onClick={() => {
						if (fields['products'].length < 8)
							fields['products'].addField();
						if (productsPanOpen == false) {
							this.props.openProductsPan();
						}
						self.refs['tabContainer'].setState({ activeKey: fields['products'].length })

					}}><i className="fa fa-plus-circle" /> {t('ficheForm.add_pristine_product')} 
		    </button> <span onClick={() => this.props.openProductsPan()}>{openIcon}</span>
				</div>

				<div className="col-xs-8" style={{ position: 'absolute', right: 200, 'zIndex': '100', 'textAlign': 'right' }}>

					<button disabled={listProducts.length == 0} style={{ margin: '0px' }} className="btn btn-info btn-sm " type="button" onClick={() => {
						this.props.openProductsListPan()

					}}><i className="fa fa-plus-circle" /> {t('ficheForm.add_existing_product')}
			    </button>

					<Panel collapsible expanded={this.props.productsListPanOpen} style={{ border: '1x solid black', background: '#f1f7fd', display: this.props.productsListPanOpen ? 'block' : 'none' }} >
						<SyncProductsTable closePlistTable={() => { this.props.openProductsListPan() }} products={listProducts} addExistingProduct={this.addExistingProduct} />
					</Panel>
				</div>
				<div className="col-xs-12">
					<p>{t('ficheForm.first_product_is_main')} (gateway).</p>
				</div>
				<div className="col-xs-12">
					{tabContainer}
				</div>
			</Panel>
		//) : '';


		if (this.props.action == 'update') {
			var state = this.props.pristineValues.sites.etat;
			var site = this.props.site;
			var sFields = this.props.fields.sites;
			var smsPanel = ''/*<SiteStatePanel
		  	sFields={sFields}
		  	site={this.props.values.sites}
		  	state={state}
		  	urlParams={this.props.urlParams}
		  />*/
		} else {
			var smsPanel = '';
		}

		var firstProductId = firstProductId != '' ? <b>{t('ficheForm.main_idptu')} : {firstProductId} </b> : '';
		var addGrpPath = user.role == 'admin' ? '/admin/groups/' + this.props.urlParams.id + '/create' : '/client/addGroup';
		var openIcon = this.props.productsPanOpen ? <i style={{ cursor: 'pointer' }} className="fa fa-chevron-circle-down" /> : <i style={{ cursor: 'pointer' }} className="fa fa-chevron-circle-up" />

		var formErrors = [];

		_.each(fields.sites, (p) => {
			if ('invalid' in p) {
				if (p.invalid == true) {
					formErrors.push(<div>{p.name.split('.')[1]} : {p.error}</div>)
				}
			}
		});

		var num = 0;
		_.each(fields.products, (p) => {
			num++;
			_.each(p, (pp) => {

				if ('invalid' in pp) {
					if (pp.invalid == true) {

						var name = _.where(productForm2, { name: pp.name.split('.')[1] })[0].label;

						formErrors.push(<div>{t("main.product")+ ' ' + num + ', ' + name} : {pp.error}</div>)
					}
				}
			});
		});


		if (pristine == true) {
			formErrors.push(<div>{t('ficheForm.modify_to_update')}</div>)
		}

		var formAlert = <div className="alert alert-danger" role="alert">{formErrors}</div>

		return (
			<div className="col-xs-12">

				<form className="form-horizontal" >

					{this.props.action == 'update' &&
						<span>{firstProductId}</span>
					}
					<fieldset style={{ marginTop: '10px' }}>
						<legend>{t('ficheForm.site_products')}</legend>
						<div className="col-xs-12">
							{tabWrapper}
						</div>
					</fieldset>

					<hr />

					<div className="row">
						<div className="col-xs-6">
							<fieldset style={{ marginTop: '10px' }}>
								<legend>{t('ficheForm.site_groups')}</legend>

								{groups.length == 0 &&
									<LinkContainer to={addGrpPath}>
										<a>{t('ficheForm.add_group_to_associate')}</a>
									</LinkContainer>
								}

								{groups.length > 0 &&
									<div className="form-group">
										<select className="form-control" name="groups" style={{ width: '300px', maxWidth: 'calc(100% - 15px)', marginLeft: '15px' }} multiple {...fields['groups']}>
											{groups.map(group => <option key={group.id} value={group.id}>{group.name}</option>)}
										</select>
										<Button style={{ verticalAlign: 'top' }} bsSize="xs" bsStyle="primary" onClick={() => { fields.groups.onChange([]) }}>{t('main.deselect')}</Button>
									</div>
								}

								<br /><br />
							</fieldset>
						</div>
					</div>

					{smsPanel}

					<div className="row">
						{SitesformGroups}
					</div>

					<div className="col-xs-12">
						<button type="button" className="btn btn-default"
							disabled={submitting} onClick={() => this.props.goBack()}>
							<i className="fa fa-ban" /> {t('main.return')}
						</button>

						<button type="button" className="btn btn-default"
							disabled={submitting} onClick={() => {
								this.props.initializeForm(this.props.pristineValues)
							}}>
							<i className="fa fa-ban" /> {t('main.reset')}
						</button>

						&nbsp;&nbsp;

						{this.props.action == 'update' &&

							<button className="btn btn-success"
								onClick={handleSubmit(() => {
									if (this.props.action == 'update') {
										save(values, fields, this.props.urlParams, this.props.pristineValues)
											.then(result => {
												if (result && typeof result.error === 'object') {
													return Promise.reject(result.error);
												}
											})
									} else {
										createFiche(values, this.props.urlParams);
									}
								}
								)}
								disabled={invalid || pristine || submitting}>
								<i className={'fa ' + (submitting ? 'fa-cog fa-spin' : 'fa-cloud')} /> {t('main.save')}
					  </button>
						}

						{this.props.action == 'create' &&
							<button onClick={handleSubmit(() =>
								createFiche(values, this.props.urlParams)
							)} type="submit" className="btn btn-success" disabled={invalid || submitting}>
								<i className={'fa ' + (submitting ? 'fa-cog fa-spin' : 'fa-cloud')} /> {t('ficheForm.add_site')}
						  </button>
						}

						<br />
						<br />
						<div className="col-xs-12 col-sm-6">
							{formErrors.length > 0 &&
								<div>{formAlert}</div>
							}
							{errorObj}
							{successObj}
						</div>
					</div>
				</form>
			</div>
		);
	}
}
